import {create} from "./_api";

const api = create();

export const delivery = api;

export default {
    api,
    install(app, options = {}) {

        api.defaults.baseURL = options.baseURL;
        api.defaults.params = options.params;

        app.provide("$delivery", api);
        app.config.globalProperties.$delivery = api;
    }
}